import { useContext, useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import { UserContext } from "../../../context/User.context";

import {
  Button,
  Col,
  Form,
  Popconfirm,
  Modal,
  Skeleton,
  Row,
  QRCode,
  Space,
  Select,
  Breadcrumb,
  Tag,
  Table,
  message,
} from "antd";

import {
  ExportOutlined,
  ImportOutlined,
  InfoCircleTwoTone,
  HomeOutlined,
  PhoneOutlined,
  UsergroupAddOutlined,
  ApartmentOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  CarOutlined,
  CheckCircleOutlined,
  BookOutlined,
  ClockCircleFilled,
} from "@ant-design/icons";
import {
  formatDate,
  formatTimeDate,
  isDatePassed,
} from "../../../utils/DateTime";
import { useHttp } from "../../../utils/DataHendler";
import { debounce } from "lodash"; // Menggunakan lodash untuk debounce

export const DetailVisitor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { code } = useParams();
  const { getData, patchData } = useHttp();

  const { routeFrom } = location.state || {}; //untuk mengetahui params property yang diterima dari page lain

  const { user } = useContext(UserContext);
  const [form] = Form.useForm();

  const [detailData, setDetailData] = useState([]);
  const [dataCardVisitor, setCardVisitor] = useState([]);
  const [cardBackOpen, setcardBackOpen] = useState(false);
  const [cardAddOpen, setcardAddOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingCard, setLoadingCard] = useState(false);

  const [typeCard, setTypeCard] = useState({});

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getVisitor();
    // getCardVisitor();
  }, [user, code]);

  const getVisitor = async () => {
    setLoading(true);

    try {
      const response = await getData(`/visitor/${code}`, {}, true);

      const data = response.data;

      setDetailData(data);
      getCardVisitor(null, data.visitor_type_id);
      setTypeCard({ type_card: data.visitor_type_name });

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getCardVisitor = async (search, visitor_type_id) => {
    setLoadingCard(true);
    // Membuat objek queryParams yang hanya berisi parameter yang ada nilai
    const queryParams = {};

    // console.log("INI TYPE VISITOR CARD :" + type);

    // Tambahkan department_id jika tersedia
    if (visitor_type_id) {
      queryParams.visitor_type_id = visitor_type_id;
    }

    // Tambahkan search jika tersedia
    if (search && search.trim() !== "") {
      queryParams.search = search.trim(); // Pastikan tidak ada spasi ekstra
    }

    try {
      const response = await getData(
        `/card/lookup`,
        { params: queryParams },
        true
      );

      const data = response.data.data;

      setCardVisitor(data);
      setLoadingCard(false);
    } catch (error) {
      console.log(error);
      setLoadingCard(false);
    }

    // await axios
    //   .get(`https://cmi-general-platform-be.vercel.app/card/lookup`, {
    //     params: queryParams,
    //   })
    //   .then((res) => {
    //     const { data } = res.data;

    //     setCardVisitor(data);
    //     setLoadingCard(false);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setLoadingCard(false);
    //   });
  };

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    // getCardVisitor(value, typeCard.type_card);
  };

  // Fungsi debounce untuk getData
  const debounceSearchCard = useCallback(
    debounce((value) => {
      // console.log("Debounced search value:", value.search, value.type);
      // console.log(value);
      getCardVisitor(value.search, value.type); // Panggil fungsi getData dengan nilai pencarian
      // form.resetFields();
    }, 1000), // Delay 500ms sebelum memanggil getData
    []
  );

  const onCardPicked = async (value, visitorId) => {
    setLoadingCard(true);
    try {
      await patchData(
        `/visitor/card/process`,
        {
          visitorId: visitorId,
          cardIds: value[`cardIds-${visitorId}`],
          action: "pick",
        },
        {},
        true
      );

      await getVisitor();
      form.resetFields();

      messageApi.success("Card added successfully");
      setLoadingCard(false);
      setcardAddOpen(false);
    } catch (error) {
      console.log(error);
      setLoadingCard(false);
      setcardAddOpen(false);

      messageApi.error("Failed to add card");
      // setLoading(false);
      // setcardAddOpen(false);
    }
  };

  const showModalCardBack = () => {
    setcardBackOpen(true);
  };
  const showModalCardAdd = () => {
    setcardAddOpen(true);
  };

  const onCardReturn = async (value, visitorId) => {
    setLoading(true);

    // console.log({
    //   visitorId: visitorId,
    //   cardIds: value[`return-cardIds-${visitorId}`],
    // });
    form.resetFields();
    try {
      await axios.patch(
        `https://cmi-general-platform-be.vercel.app/visitor/card/process`,
        {
          visitorId: visitorId,
          cardIds: value[`return-cardIds-${visitorId}`],
          action: "return",
        },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      messageApi.success("Card returned successfully");

      setcardBackOpen(false);
      getVisitor();
    } catch (err) {
      console.log(err);
      messageApi.error("Failed to return card");
      setcardBackOpen(false);
      setLoading(false);
    }
  };

  const ModalAddCard = () => {
    return (
      <>
        <Modal
          title="ADD CARD"
          open={cardAddOpen}
          onOk={showModalCardAdd}
          onCancel={() => {
            setcardAddOpen(false);
          }}
          // okButtonProps={{ disabled: true }}
          // cancelButtonProps={{ disabled: true }}
          footer={null}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={(value) => {
              onCardPicked(value, detailData.id);
            }}
            autoComplete="off"
            style={{ textAlign: "left" }}
          >
            <Form.Item
              name={`cardIds-${detailData.id}`}
              rules={
                [
                  //   {
                  //     required: true,
                  //   },
                ]
              }
              label={
                <div
                  style={{
                    fontWeight: "bold",
                    borderBottom: "2px solid #088395",
                    paddingBottom: "5px",
                    width: "fit-content",
                  }}
                >
                  CARD
                </div>
              }
            >
              {/* <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="select one visitor"
                disabled={loadingCard}
                onChange={handleChange}
                // onSearch={(val) => {
                //   console.log(val);
                // }}
                filterOption={async (input, option) => {
                  // console.log("disini aja");
                  return await debounceSearchCard({
                    search: input,
                    type: detailData.visitor_type_name,
                  });
                }}
                options={dataCardVisitor.map((el) => ({
                  label: el.name,
                  value: el.id,
                  emoji: el.code,
                  desc: el.type,
                }))}
                optionRender={(option) => (
                  <Space>
                    <span role="img" aria-label={option.data.label}>
                      {option.data.emoji}
                    </span>
                    {option.data.desc}
                  </Space>
                )}
              /> */}
              <Select
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder="select one visitor"
                disabled={loadingCard}
                // onChange={(value) => {
                //   console.log(`baru baru` + value);
                // }}
                options={dataCardVisitor.map((el) => ({
                  label: el.code,
                  value: el.id,
                }))}
                filterOption={async (input, option) => {
                  return await debounceSearchCard({
                    search: input,
                    type: detailData.visitor_type_id,
                  });
                }}
              />
            </Form.Item>

            <Form.Item style={{ marginTop: "0px", textAlign: "left" }}>
              <Form.Item shouldUpdate>
                {() => {
                  const selected = form.getFieldValue(
                    `cardIds-${detailData.id}`
                  );
                  return (
                    <Space size="middle">
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingCard}
                        disabled={!selected || selected.length === 0}
                      >
                        Add Card
                      </Button>
                    </Space>
                  );
                }}
              </Form.Item>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  };
  // LOADING COMPONENT
  const LoadingSkeleton = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center", // Memastikan elemen sejajar secara vertikal
          gap: "20px", // Jarak antara QR Code dan detail pengunjung
          padding: "20px", // Padding untuk memberikan ruang di sekitar konten
        }}
      >
        {/* Skeleton untuk QR Code */}
        <div>
          <Skeleton.Image
            active
            style={{
              width: 130, // Ukuran QR Code
              height: 130,
              borderRadius: "8px", // Rounded corner untuk tampilan modern
            }}
          />
        </div>

        {/* Skeleton untuk Detail Pengunjung */}
        <div
          style={{
            display: "flex",
            flexDirection: "column", // Menyusun detail pengunjung secara vertikal
            gap: "10px", // Jarak antar elemen detail pengunjung
          }}
        >
          {/* Nama Pengunjung */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>

          {/* Nomor Identitas */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>

          {/* Kode Pengunjung */}
          <div>
            <Skeleton.Input
              active
              style={{
                width: "150px", // Lebar placeholder untuk label
                height: "16px",
                marginBottom: "5px", // Jarak antara label dan value
              }}
            />
            <Skeleton.Input
              active
              style={{
                width: "200px", // Lebar placeholder untuk value
                height: "20px",
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  // const CardPicked = () => {
  //   return
  // };

  const data = [
    {
      key: "1",
      title: (
        <Space>
          <HomeOutlined style={{ color: "#088395" }} /> Address
        </Space>
      ),
      value: detailData.detail_address || "-",
    },
    {
      key: "2",
      title: (
        <Space>
          <HomeOutlined style={{ color: "#088395" }} /> Institution
        </Space>
      ),
      value: detailData.detail_institution || "-",
    },
    {
      key: "3",
      title: (
        <Space>
          <PhoneOutlined style={{ color: "#088395" }} /> Phone
        </Space>
      ),
      value: detailData.detail_phone || "-",
    },
    {
      key: "4",
      title: (
        <Space>
          <UsergroupAddOutlined style={{ color: "#088395" }} /> Type Visitor
        </Space>
      ),
      value: detailData.visitor_type_name || "-",
    },

    {
      key: "5",
      title: (
        <Space>
          <ApartmentOutlined style={{ color: "#088395" }} /> Department
        </Space>
      ),
      value: detailData.department_name || "-",
    },
    {
      key: "6",
      title: (
        <Space>
          <CalendarOutlined style={{ color: "#088395" }} /> Appointments
        </Space>
      ),
      value: detailData.detail_appointment || "-",
    },

    {
      key: "7",
      title: (
        <Space>
          <ClockCircleOutlined style={{ color: "#088395" }} /> Visit Deadline
        </Space>
      ),
      value: (
        <>
          {detailData.detail_expired_at == null ? (
            <span
              style={{
                color: "red",
                fontSize: "12px",
                // fontWeight: "normal",
                animation: "blink 1s infinite",
              }}
            >
              Please verify to start access
            </span>
          ) : (
            <Tag
              color={
                isDatePassed(detailData.detail_expired_at) ? "red" : "#088395"
              } // Warna sesuai status is_take
              style={{
                fontWeight: "bold",
                padding: "5px 10px", // Padding untuk membuat Tag lebih besar dan mudah dibaca
                animation: isDatePassed(detailData.detail_expired_at)
                  ? "blink 1s infinite"
                  : "", // Efek blink
              }}
            >
              <ClockCircleOutlined
                style={{
                  color: isDatePassed(detailData.detail_expired_at)
                    ? "red"
                    : "white",
                  marginRight: 3,
                }}
              />{" "}
              {formatDate(detailData.detail_expired_at)}
            </Tag>
          )}
        </>
      ),
    },
    {
      key: "8",
      title: (
        <Space>
          <ClockCircleOutlined style={{ color: "#088395" }} /> Visit Time
        </Space>
      ),
      value: (
        <>
          <Tag
            // Warna sesuai status is_take
            style={{
              fontWeight: "bold",
              padding: "5px 10px", // Padding untuk membuat Tag lebih besar dan mudah dibaca
            }}
          >
            <ClockCircleOutlined
              style={{
                color: "red",
                marginRight: 3,
              }}
            />{" "}
            {detailData.detail_visitor_time}
          </Tag>
        </>
      ),
    },
    {
      key: "9",
      title: (
        <Space>
          <InfoCircleOutlined style={{ color: "#088395" }} /> Purpose
        </Space>
      ),
      value: detailData.detail_description || "-",
    },
    {
      key: "10",
      title: (
        <Space>
          <CheckCircleOutlined style={{ color: "#088395" }} /> Approve At
        </Space>
      ),
      value:
        detailData.approve_at == null
          ? "Please verify to start access"
          : formatDate(detailData.approve_at),
    },
    {
      key: "11",
      title: (
        <Space>
          <BookOutlined style={{ color: "#088395" }} /> Status
        </Space>
      ),
      value: (
        <>
          {detailData.active == null ? (
            <span
              style={{
                color: "red",
                fontSize: "12px",
                // fontWeight: "normal",
                animation: "blink 1s infinite",
              }}
            >
              Visitor Not Yet Verified by Security
            </span>
          ) : (
            <Tag
              color={detailData.active == "OUT" ? "red" : "green"} // Warna sesuai status is_take
              style={{
                fontWeight: "bold",
                padding: "5px 10px", // Padding untuk membuat Tag lebih besar dan mudah dibaca
              }}
            >
              {detailData.active == "OUT" ? (
                <ExportOutlined style={{ color: "red", marginRight: 3 }} />
              ) : (
                <ImportOutlined style={{ color: "green", marginRight: 3 }} />
              )}{" "}
              {detailData.active}
            </Tag>
          )}
        </>
      ),
    },
    {
      key: "12",
      title: (
        <Space>
          <ImportOutlined style={{ color: "#088395" }} /> Verifikator In
        </Space>
      ),
      value: (
        <>
          {detailData.verifikator_in_name == null ? (
            <span
              style={{
                color: "red",
                fontSize: "12px",
                // fontWeight: "normal",
                animation: "blink 1s infinite",
              }}
            >
              Visitor Not Yet Verified IN by Security
            </span>
          ) : (
            detailData.verifikator_in_name
          )}
        </>
      ),
    },
    {
      key: "13",
      title: (
        <Space>
          <ExportOutlined style={{ color: "red" }} /> Verifikator Out
        </Space>
      ),
      value: (
        <>
          {detailData.verifikator_out_name == null ? (
            <span
              style={{
                color: "red",
                fontSize: "12px",
                // fontWeight: "normal",
                animation: "blink 1s infinite",
              }}
            >
              Visitor Not Yet Verified Out by Security
            </span>
          ) : (
            detailData.verifikator_out_name
          )}
        </>
      ),
    },
  ];

  // Tambahkan informasi kendaraan hanya jika detailData.is_vehicle bernilai true
  if (detailData.is_vehicle) {
    data.push({
      key: "14",
      title: (
        <Space>
          <CarOutlined style={{ color: "#088395" }} /> Vehicle
        </Space>
      ),
      value: (
        <>
          <Tag color="blue">{detailData.fleet_number || "-"}</Tag>
          <Tag color="green">{detailData.type_vehicle || "-"}</Tag>
        </>
      ),
    });
  }

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: "40%",
    },
    {
      title: "Detail",
      dataIndex: "value",
      key: "value",
      width: "60%",
    },
  ];

  return (
    <>
      {contextHolder}
      <ModalAddCard />
      <Row justify="center">
        <Col xs={24} sm={22} md={18} lg={14}>
          <>
            <div
              style={{
                marginBottom: "30px",
                borderBottom: "2px solid #088395",
                padding: "10px 15px 0px",
                display: "flex",
                alignItems: "center", // Memastikan elemen sejajar secara vertikal
                justifyContent: "space-between", // Menyusun elemen di antara ruang kosong
              }}
            >
              {/* Breadcrumb */}

              {routeFrom == "detail-card" ? (
                <Breadcrumb style={{ margin: 0 }}>
                  <Breadcrumb.Item>
                    <a
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Detail Card
                    </a>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item style={{ fontWeight: "bold" }}>
                    Visitor Profile
                  </Breadcrumb.Item>
                </Breadcrumb>
              ) : (
                <Breadcrumb style={{ margin: 0 }}>
                  <Breadcrumb.Item>
                    <a
                      onClick={() => {
                        navigate("/user");
                      }}
                    >
                      Dashboard
                    </a>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item style={{ fontWeight: "bold" }}>
                    Visitor Profiles
                  </Breadcrumb.Item>
                </Breadcrumb>
              )}

              {/* Judul "PROFILE VISITOR" */}
              <div
                style={{
                  margin: 0, // Menghapus margin default dari Title
                  textAlign: "right", // Memastikan teks rata kanan
                  color: "#088395", // Warna teks sesuai tema
                  fontWeight: "bold", // Membuat teks lebih tebal
                }}
              >
                VISITOR PROFILE
              </div>
            </div>
            {loading ? (
              <LoadingSkeleton />
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center", // Memastikan elemen di dalam flex container sejajar secara vertikal
                    gap: "20px", // Menambahkan jarak antara QR Code dan detail pengunjung
                  }}
                >
                  {/* QR Code */}
                  <QRCode
                    id="myqrcode" // ID untuk referensi elemen QR Code
                    size={130}
                    errorLevel="H"
                    value={`${detailData.code}`} // Nilai yang akan di-encode ke dalam QR Code
                    style={{
                      border: "2px solid #2C74B3", // Border untuk QR Code
                      backgroundColor: "#fff", // Warna latar belakang QR Code
                      padding: "10px", // Padding untuk memberikan ruang di dalam border
                      borderRadius: "8px", // Rounded corner untuk tampilan lebih modern
                    }}
                    bgColor="#fff" // Background color untuk QR Code
                    type="canvas" // Pastikan tipe adalah "canvas"
                  />

                  {/* Detail Pengunjung */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column", // Menyusun detail pengunjung secara vertikal
                      gap: "10px", // Jarak antar elemen detail pengunjung
                    }}
                  >
                    {/* Nama Pengunjung */}
                    <div>
                      <div
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #088395",
                          paddingBottom: "5px",
                          width: "fit-content",
                        }}
                      >
                        Visitor Name
                      </div>
                      <p style={{ margin: "0", textAlign: "left" }}>
                        {detailData.detail_name}
                      </p>
                    </div>

                    {/* Nomor Identitas */}
                    <div>
                      <div
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #088395",
                          paddingBottom: "5px",
                          width: "fit-content",
                        }}
                      >
                        Identity Number
                      </div>
                      <p style={{ margin: "0", textAlign: "left" }}>
                        {detailData.detail_id_number}
                      </p>
                    </div>

                    {/* Kode Pengunjung */}
                    <div>
                      <div
                        style={{
                          fontWeight: "bold",
                          borderBottom: "2px solid #088395",
                          paddingBottom: "5px",
                          width: "fit-content",
                        }}
                      >
                        Visitor Code
                      </div>
                      <p style={{ margin: "0", textAlign: "left" }}>
                        {detailData.code}
                      </p>
                    </div>
                  </div>
                </div>
                <Table
                  dataSource={data}
                  columns={columns}
                  pagination={false}
                  bordered
                  size="small"
                  style={{
                    border: "1px solid #088395",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                />

                {/* Bagian Tabel Visitor Lists */}
                <div
                  style={{
                    margin: "10px 0 10px 0",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <h2 style={{ textAlign: "left" }}>List of Visitors</h2>
                  {detailData?.visitor_list &&
                  detailData.visitor_list.length > 0 ? (
                    <Table
                      dataSource={detailData.visitor_list.map((item) => ({
                        key: item.id,
                        name: item.name,
                        nik: item.nik,
                      }))}
                      columns={[
                        {
                          title: "Name",
                          dataIndex: "name",
                          key: "name",
                        },
                        {
                          title: "NIK",
                          dataIndex: "nik",
                          key: "nik",
                        },
                      ]}
                      pagination={false}
                      size="small"
                    />
                  ) : (
                    <p style={{ textAlign: "center", fontStyle: "italic" }}>
                      No visitor lists available.
                    </p>
                  )}
                </div>
                {/* KARTU */}
                <>
                  {detailData.card_visitors?.length <= 0 ? (
                    detailData.detail_expired_at === null ? (
                      <>
                        <div
                          style={{
                            fontWeight: "bold",
                            borderBottom: "2px solid #088395",
                            paddingBottom: "5px",
                            width: "fit-content",
                          }}
                        >
                          PICK CARD
                        </div>
                        <p
                          style={{
                            color: "red",
                            fontSize: "12px",
                            // fontWeight: "normal",
                            animation: "blink 1s infinite",
                            textAlign: "left",
                            margin: "5px 0 10px 0",
                          }}
                        >
                          {
                            "Wait for Approval to be Able to Choose a Visitor Card"
                          }
                        </p>
                      </>
                    ) : (
                      <>
                        <Form
                          form={form}
                          layout="vertical"
                          onFinish={(value) => {
                            onCardPicked(value, detailData.id);
                          }}
                          autoComplete="off"
                          style={{ textAlign: "left" }}
                        >
                          <Form.Item
                            name={`cardIds-${detailData.id}`}
                            rules={
                              [
                                //   {
                                //     required: true,
                                //   },
                              ]
                            }
                            label={
                              <div
                                style={{
                                  fontWeight: "bold",
                                  borderBottom: "2px solid #088395",
                                  paddingBottom: "5px",
                                  width: "fit-content",
                                }}
                              >
                                PICK CARD
                              </div>
                            }
                          >
                            <Select
                              mode="multiple"
                              style={{ width: "100%" }}
                              placeholder="select one visitor"
                              // disabled={loadingCard}
                              onChange={handleChange}
                              allowClear
                              onClear={() => {
                                getCardVisitor(
                                  null,
                                  detailData.visitor_type_name
                                );
                              }}
                              loading={loadingCard}
                              // onSearch={(value) => {
                              //   return debounceSearchCard({
                              //     search: value,
                              //     type: detailData.visitor_type_name,
                              //   });
                              // }}
                              filterOption={async (input, option) => {
                                // console.log(input);
                                // MENGALAMI DELAY
                                return await debounceSearchCard({
                                  search: input,
                                  type: detailData.visitor_type_id,
                                });
                                // var _a;
                                // return (
                                //   (_a =
                                //     option === null || option === void 0
                                //       ? void 0
                                //       : option.label) !== null && _a !== void 0
                                //     ? _a
                                //     : ""
                                // )
                                //   .toLowerCase()
                                //   .includes(input.toLowerCase());
                              }}
                              options={dataCardVisitor.map((el) => ({
                                label: el.name,
                                value: el.id,
                                emoji: el.code,
                                desc: el.type,
                              }))}
                              optionRender={(option) => (
                                <Space>
                                  <span
                                    role="img"
                                    aria-label={option.data.label}
                                  >
                                    {option.data.emoji}
                                  </span>
                                  {option.data.desc}
                                </Space>
                              )}
                            />
                          </Form.Item>

                          <Form.Item
                            style={{ marginTop: "0px", textAlign: "left" }}
                          >
                            <Space size="middle">
                              <Button
                                type="primary"
                                htmlType="submit"
                                loading={loadingCard}
                              >
                                Pick Card
                              </Button>
                            </Space>
                          </Form.Item>
                        </Form>
                      </>
                    )
                  ) : (
                    <>
                      <div>
                        <div
                          style={{
                            fontWeight: "bold",
                            borderBottom: "2px solid #088395",
                            paddingBottom: "5px",
                            width: "fit-content",
                          }}
                        >
                          Card Used
                          <Popconfirm
                            placement="rightTop"
                            title={"Additional Options"}
                            description={"Select additional actions"}
                            okText="Add Cards"
                            cancelText="Return Card"
                            onConfirm={() => {
                              showModalCardAdd();
                              // console.log("INI DISISNI LHO");
                            }}
                            onCancel={() => {
                              showModalCardBack();
                              // console.log("INI BACK");
                            }}
                            okButtonProps={
                              isDatePassed(detailData.detail_expired_at) ||
                              detailData.active == "OUT"
                                ? { style: { display: "none" } }
                                : {}
                            }
                          >
                            {detailData.status_code == "UNVERIFIED" ? (
                              <></>
                            ) : (
                              <Button
                                style={{ marginLeft: "5px" }}
                                type="dashed"
                                icon={<InfoCircleTwoTone />}
                              />
                            )}
                          </Popconfirm>
                        </div>

                        <Modal
                          title="Return Card"
                          open={cardBackOpen}
                          onOk={showModalCardBack}
                          onCancel={() => {
                            setcardBackOpen(false);
                          }}
                          footer={null}
                        >
                          <Form
                            form={form}
                            layout="vertical"
                            onFinish={(value) => {
                              console.log("disini");
                              // onCardReturn(value, detailData.id);
                              onCardReturn(value, detailData.id);
                            }}
                            autoComplete="off"
                            style={{ textAlign: "left" }}
                          >
                            <Form.Item
                              name={`return-cardIds-${detailData.id}`}
                              label={
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    borderBottom: "2px solid #088395",
                                    paddingBottom: "5px",
                                    width: "fit-content",
                                  }}
                                >
                                  Pick Card
                                </div>
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "Please select card(s) to return",
                                },
                              ]}
                            >
                              <Select
                                mode="multiple"
                                allowClear
                                style={{ width: "100%" }}
                                placeholder="Please select"
                                // defaultValue={["a10", "c12"]}
                                onChange={handleChange}
                                // filterOption={(input, option) =>
                                //   (option?.label ?? "")
                                //     .toLowerCase()
                                //     .includes(input.toLowerCase())
                                // }
                                options={detailData?.card_visitors
                                  ?.filter((card) => card.returned_at === null)
                                  .map((el) => ({
                                    label: el.card_name,
                                    value: el.card_visitor_id,
                                  }))}

                                // optionRender={(option) => (
                                //   <Space>
                                //     <span
                                //       role="img"
                                //       aria-label={option.data.label}
                                //     >
                                //       {option.data.emoji}
                                //     </span>
                                //     {option.data.desc}
                                //   </Space>
                                // )}
                              />
                            </Form.Item>

                            <Form.Item shouldUpdate>
                              {() => {
                                const selected = form.getFieldValue(
                                  `return-cardIds-${detailData.id}`
                                );
                                return (
                                  <Space size="middle">
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      loading={loading}
                                      disabled={
                                        !selected || selected.length === 0
                                      }
                                    >
                                      Return Card
                                    </Button>
                                  </Space>
                                );
                              }}
                            </Form.Item>
                          </Form>
                        </Modal>

                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap", // Memungkinkan elemen pindah ke baris baru jika tidak cukup ruang
                            gap: "10px", // Menambahkan jarak antara Tag
                            marginTop: "5px",
                          }}
                        >
                          {detailData.card_visitors?.map((el) => (
                            <Tag
                              key={el.card_code} // Tambahkan key untuk setiap Tag agar lebih optimal
                              color={el.returned_at ? "red" : "green"} // Warna sesuai status is_take
                              style={{
                                fontWeight: "bold",
                                padding: "5px 10px", // Padding untuk membuat Tag lebih besar dan mudah dibaca
                              }}
                            >
                              {`${el.card_code}`}
                              {el.returned_at != null ? ` | ` : ""}
                              <i>
                                {el.returned_at != null
                                  ? ` ${formatTimeDate(el.returned_at)}`
                                  : ""}
                              </i>
                            </Tag>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </>
              </>
            )}
          </>
        </Col>
      </Row>
    </>
  );
};
